module.exports = __webpack_public_path__ + "media/images/steps_active_right_flat-9578a8cb128c82df9c2d09e8519fbbeb.png";